// Default "Contact to Build" SOP — the built-in fallback used when no CRM master
// template (contactToBuildTemplate/data) and no per-account customization exist.
// Shared by the portal (SOPs.js) and the CRM template editor.

export const CONTACT_TO_BUILD_GOAL =
  'Provide clients with an efficient and effective timeline from initial consult to build.';

export const CONTACT_TO_BUILD_NOTE =
  'It is important that the Project Director and Design team coordinate when scheduling the next meeting with deliverables to ensure a reasonable and expedient timeline.';

export const CONTACT_TO_BUILD_STEPS = [
  { action: 'Qualification Call', assignedTo: 'Project Director' },
  { action: 'Meeting Confirmation Email', assignedTo: 'Project Director' },
  { action: 'Home Consultation', assignedTo: 'Project Director' },
  { action: 'Scope Clarification', assignedTo: 'Project Director' },
  { action: 'Design Proposal Presented To Clients In Office', assignedTo: 'Project Director / Client Services Coordinator' },
  { action: 'Design Template Created', assignedTo: 'Project Director' },
  { action: 'Design Contract Created / Sent', assignedTo: 'Bookkeeper' },
  { action: 'Schedule Measure Meeting', assignedTo: 'Design Director' },
  { action: 'Establish Design Timeline', assignedTo: 'Design Director' },
  { action: 'Schedule Survey (as needed)', assignedTo: 'Estimator' },
  { action: 'Pre Measure Huddle', assignedTo: 'Project Director / Designer / Draftsman / Estimator' },
  { action: 'Attend Measure Meeting', assignedTo: 'Project Director / Designer / Draftsman / Estimator' },
  { action: 'Post Existing Conditions', assignedTo: 'Draftsman' },
  { action: 'Post Proposed Conditions', assignedTo: 'Draftsman' },
  { action: 'Schedule Redline Meeting', assignedTo: 'Project Director' },
  { action: 'Attend Redline Meeting', assignedTo: 'Project Director / Designer / Draftsman / Estimator' },
  { action: 'Schedule Selections Meeting', assignedTo: 'Design / Project Director' },
  { action: 'Attend Selections Meeting', assignedTo: 'Project Director / Design' },
  { action: 'Post Selections', assignedTo: 'Design' },
  { action: 'Selections Posted Notification', assignedTo: 'Design' },
  { action: 'Engineer Consult (as needed)', assignedTo: 'Estimator' },
  { action: 'Construction Draft set of plans', assignedTo: 'Design' },
  { action: 'Build out the Specs and Selections in Coconstruct', assignedTo: 'Estimator' },
  { action: 'Schedule Trades Day', assignedTo: 'Estimator' },
  { action: 'PD Scope Meeting', assignedTo: 'Project Director / Designer / Draftsman / Estimator' },
  { action: 'Attend Trades Day', assignedTo: 'Project Director / Design / Estimator / PM' },
  { action: 'Secure Sub Bids / Vendor Pricing', assignedTo: 'Estimator' },
  { action: 'Engineer Consult', assignedTo: 'Estimator' },
  { action: 'Finalize Selections', assignedTo: 'Design' },
  { action: 'Schedule Money Meeting', assignedTo: 'Project Director' },
  { action: 'Attend Money Meeting', assignedTo: 'Project Director / Design / Estimator' },
  { action: 'Project Review', assignedTo: 'Project Director' },
  { action: 'Revise / finalize Specs and Selections for Build Proposal', assignedTo: 'Estimator / Project Director / Design' },
  { action: 'Project Team Review', assignedTo: 'Project Director / Design / Estimator / Draftsman / PM' },
  { action: 'Present Build Proposal', assignedTo: 'Project Director' },
  { action: 'Create Build Contract Template', assignedTo: 'Project Director' },
  { action: 'Create Build Contract', assignedTo: 'Bookkeeper' },
  { action: 'Secure Build Contract', assignedTo: 'Project Director' },
  { action: 'Construction Drawings', assignedTo: 'Draftsman' },
  { action: 'Apply For Permit', assignedTo: 'Estimator' },
];
